import { AuthService } from './authService';

export interface DiscoveredLead {
  name: string;
  website: string;
  description: string;
  industry?: string;
  location?: string;
  emails: string[];
  phones: string[];
}

/**
 * Live lead discovery via de Firecrawl-endpoint van de API (/api/lead-finder/discover).
 * Dit levert echte bedrijven van het internet op in plaats van modelgeheugen.
 */
export class LeadSearchService {
  static async discover(query: string, limit = 10, location?: string): Promise<DiscoveredLead[]> {
    const trimmed = (query || '').trim().slice(0, 490);
    if (trimmed.length < 3) return [];

    const response = await AuthService.authFetch('/api/lead-finder/discover', {
      method: 'POST',
      headers: AuthService.authHeaders(true),
      body: JSON.stringify({
        projectDescription: trimmed,
        location: location || undefined,
        limit: Math.min(Math.max(limit, 1), 25),
      }),
    });

    if (!response.ok) {
      const payload = await response.json().catch(() => null);
      throw new Error(payload?.error || `Live lead zoeken mislukt (${response.status}).`);
    }

    const payload = await response.json().catch(() => null);
    return Array.isArray(payload?.leads) ? payload.leads : [];
  }
}
